module.exports = __webpack_public_path__ + "media/images/emblems/Blason_commune_CH_Noville_(Vaud)-8ee0fe1f6d64b0258c47ed542cc477a2.svg";